import {
  cancelRoutineTask,
  clearRoutineTask,
  useRoutineTask,
} from "@/lib/routineTasks";
export function RoutineActivity() {
  const task = useRoutineTask();
  if (!task) return null;
  return (
    <aside
      aria-label="Video processing status"
      className="fixed bottom-5 right-5 z-50 w-[min(25rem,calc(100vw-2.5rem))] rounded-2xl border border-[#e2d4de] bg-white p-5 shadow-xl"
    >
      <p className="font-semibold text-[#321b29]">{task.label}</p>
      <p role="status" className="mt-1 text-sm text-[#762a5c]">
        {task.progress.stage}
        {task.progress.percent !== undefined
          ? ` · ${task.progress.percent}%`
          : ""}
      </p>
      {task.busy && (
        <>
          <progress
            aria-label="Video progress"
            className="mt-3 w-full accent-[#762a5c]"
            max={100}
            value={task.progress.percent}
          />
          <p className="mt-2 text-sm text-gray-600">
            Keep this tab open until processing and upload finish.
          </p>
        </>
      )}
      {task.error && (
        <p role="alert" className="mt-2 break-words text-sm text-red-700">
          {task.error}
        </p>
      )}
      <button
        type="button"
        className="mt-3 text-sm font-semibold text-[#762a5c]"
        onClick={() =>
          task.busy
            ? window.confirm("Stop processing? Saved reviews will be kept.") &&
              cancelRoutineTask()
            : clearRoutineTask()
        }
      >
        {task.busy ? "Stop processing" : "Dismiss"}
      </button>
    </aside>
  );
}
